export default "__VITE_ASSET__8e31eded__"